import React from 'react';
import BiegungCard from '../JSX/BiegungCard';

const Berechnung = (props) => {
    const KraftN = parseFloat(props.Kraft);
    const Hebelarm = parseFloat(props.Laenge);

    const array = props.nameArray;
    const BF = 'BF' + props.Belastungsfall;

    // Werte aus TB
    let werte = {
        BF1: [1, 8, 3, 1, 2],
        BF2: [5, 384, 48, 4, 8],
        BF3: [1, 384, 192, 8, 12],
    };

    const Belastungfall = werte[BF];

    let IX = 0;
    let IY = 0;
    let WX = 0;
    let WY = 0;
    let Gewichtkg = 0;

    if (array !== '') {
        IX = parseFloat(array.data.attributes.ix.value);
        WX = parseFloat(array.data.attributes.wx.value);
        WY = parseFloat(array.data.attributes.wy.value);
        Gewichtkg = parseFloat(array.data.attributes.gewichtkg.value);
        if (array.data.attributes.iy === undefined) {
            IY = IX;
        } else {
            IY = parseFloat(array.data.attributes.iy.value);
        }
    }
    const G = 9.81;
    const E = () => {
        switch (props.id) {
            case '1000053109': //45x45 VA PROFIL
                return 2000000;
            case '1000062111':
                return 2100000; //C-Schiene Stahl
            default:
                return 700000;
        }
    };

    const KraftStrecke = (Gewichtkg / 1000) * G * Hebelarm;
    // Biegemoment Kraft einwirkend
    const MbPunkt = (KraftN * Hebelarm) / Belastungfall[3];
    // Biegemoment Eigengewicht
    const MbEig = (KraftStrecke * Hebelarm) / Belastungfall[4];
    // Summe Biegemoment
    const Mb = MbPunkt + MbEig;
    // fx Punkt
    const fx_Punkt =
        (KraftN * Math.pow(Hebelarm, 3)) / (Belastungfall[2] * E() * IX * 1000);
    // fy Punkt
    const fy_Punkt =
        (KraftN * Math.pow(Hebelarm, 3)) / (Belastungfall[2] * E() * IY * 1000);
    // fx Strecke
    const fx_Strecke =
        (KraftStrecke * Math.pow(Hebelarm, 3)) /
        (Belastungfall[1] * E() * IX * 1000);
    // fy Schrecke
    const fy_Strecke =
        (KraftStrecke * Math.pow(Hebelarm, 3)) /
        (Belastungfall[1] * E() * IY * 1000);
    //fx Summe
    const fx = fx_Punkt + fx_Strecke;
    // fy Summe
    const fy = fy_Punkt + fy_Strecke;
    // Biegespannung x
    const BSPx = Mb / (WX * 1000);
    // Biegespannung y
    const BSPy = Mb / (WY * 1000);

    return (
        <>
            <BiegungCard fx={fx} fy={fy} BSPx={BSPx} BSPy={BSPy} {...props} />
        </>
    );
};

export default Berechnung;
